import { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useClickOutside } from "@mantine/hooks";
import styles from "./styles/UserSection.module.scss";
// Modals
import RanksModal from "../../../modals/ranks/Ranks";
import LogoutModal from "../../../modals/others/Logout";
// Utils
import icons from "../../../../utils/icons";
import images from "../../../../utils/images";
import userDropdownConfigs from "../../../../utils/configs/user-dropdown";

const Menu = () => {
  // Redux and states
  const userData = useSelector((state) => state.userData);
  const [showUserDropdown, setShowUserDropdown] = useState();
  const [showRanksModal, setShowRanksModal] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  // Refs and variables
  const ref = useClickOutside(
    () => showUserDropdown && setShowUserDropdown(false)
  );
  const userDropdownClassName =
    showUserDropdown === true
      ? styles.open
      : showUserDropdown === false
      ? styles.closed
      : "";
  // Functions
  function toggleModal(modal) {
    modal === "ranks" ? setShowRanksModal(true) : setShowLogoutModal(true);
  }

  return (
    <>
      <div className={styles["user-section"]}>
        <div className={styles.stock}>
          <p className={styles.header}>موجودی حساب شما</p>
          <div className={styles["stock-value"]}>
            <p>{userData.stock.toLocaleString()}</p>
            <p>تومان</p>
          </div>
          <button type={"button"}>{icons.plus}</button>
        </div>

        <div
          className={styles["user-dropdown"]}
          onClick={() => setShowUserDropdown(!showUserDropdown)}
          ref={ref}
        >
          <p>{userData.name}</p>
          <img alt={"Arrowhead"} src={images.userDropdownArrowhead} />

          <div className={userDropdownClassName}>
            {userDropdownConfigs.map((item) =>
              item.type === "button" ? (
                <button
                  key={item.title}
                  type={"button"}
                  onClick={() => toggleModal(item.modalToOpen)}
                >
                  {item.icon}
                  <p>{item.title}</p>
                </button>
              ) : (
                <Link
                  key={item.title}
                  to={item.link}
                  className={
                    item.title === "پیام‌ها" ? styles.notifications : ""
                  }
                >
                  {item.icon}
                  <p>{item.title}</p>
                </Link>
              )
            )}
          </div>
        </div>
      </div>

      <RanksModal displayStatus={showRanksModal} toggle={setShowRanksModal} />
      <LogoutModal
        displayStatus={showLogoutModal}
        toggle={setShowLogoutModal}
      />
    </>
  );
};

export default Menu;
